import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';

import 'rxjs/add/operator/toPromise';

import { URL_API } from './../constante';
import { HEADERS } from './../constante';

import { Incidente } from './incidente';
import { Classificacao } from './classificacao';

import { Encaminhamento } from './encaminhamento';

import { Finalizacao } from './finalizacao';

@Injectable()
export class IncidenteService {

  private headers = HEADERS;
  private documentoUrl = URL_API;

  getIncidentes(): Promise<Incidente[]> {
    return this.http.get(this.documentoUrl+"/tipoincidentes")
                .toPromise()
                .then(response => response.json() as Incidente[])
                .catch(this.handleError);
  }

  getClassificacao(): Promise<Classificacao[]> {
    return this.http.get(this.documentoUrl+"/classificacao")
                .toPromise()
                .then(response => response.json() as Classificacao[])
                .catch(this.handleError);
  }

  getEncaminhamento(id: number): Promise<Encaminhamento[]> {
    //console.log("id do incidente = " + id);
    return this.http.get(this.documentoUrl + "/encaminhamento/" + id)
                .toPromise()
                .then(response => response.json() as Encaminhamento[])
                .catch(this.handleError);
  }

  getFinalizacao(): Promise<Finalizacao[]> {
    return this.http.get(this.documentoUrl+"/finalizacao")
                .toPromise()
                .then(response => response.json() as Finalizacao[])
                .catch(this.handleError);
  }

  getDadosIncidente(id: number): Promise<Incidente>{
    let url: string  = this.documentoUrl + "/incidentes/" + id;
    return this.http.get(url)
               .toPromise()
               .then(response => response.json() as Incidente)
               .catch((error) => this.handleError(error));
  }

  salvarResumoCaso(incidente: Incidente): Promise<Incidente>{
    //console.log("INICIO ");
    //console.log(incidente);
    //console.log("FIM");

    let url:string = this.documentoUrl + "/incidentes/" + incidente.id;

    return this.http
               .put(url, JSON.stringify(incidente), {headers: HEADERS})
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  enviarIncidente(incidente: Incidente): Promise<Incidente>{
    //console.log("INICIO ");
    //console.log(incidente);
    //console.log("FIM");

    let url:string = this.documentoUrl + "/incidentes/" + incidente.id;

    return this.http
               .put(url, JSON.stringify(incidente), {headers: HEADERS})
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }


  salvarEncaminhamento(incidente: Incidente): Promise<Incidente>{
      //console.log("INICIO ");
      //console.log(incidente);
      //console.log("FIM");

      let url:string = this.documentoUrl + "/incidentes/" + incidente.id;

      return this.http
                 .put(url, JSON.stringify(incidente), {headers: HEADERS})
                 .toPromise()
                 .then(response => this.handleSuccess(response.json()))
                 .catch((error) => this.handleError(error));
  }

  salvarFinalizacao(incidente: Incidente): Promise<Incidente>{
      //console.log("INICIO ");
      //console.log(incidente);
      //console.log("FIM");

      let url:string = this.documentoUrl + "/finalizacao/" + incidente.id;

      return this.http
                 .put(url, JSON.stringify(incidente), {headers: HEADERS})
                 .toPromise()
                 .then(response => this.handleSuccess(response.json()))
                 .catch((error) => this.handleError(error));
  }


  buscarStatus(prot: string): Promise<string>{
        //console.log("INICIO ");
        //console.log(prot);
        //console.log("FIM");

        let url:string = this.documentoUrl + "/busca/" + prot;
        return this.http.get(url)
                   .toPromise()
                   .then(response => response.json() as string)
                   .catch((error) => this.handleError(error));
    }

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService
  ) { }

  private handleSuccess(resp: any): Promise<any> {
    this._flashMessagesService.show(resp, { cssClass: 'alert-success', timeout: 30000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
    //console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/incidente/incidente.service.ts